import Immutable from 'immutable'
import * as React from 'react'
import { Creatable } from 'react-select'
import isEmpty from 'lodash.isempty'
import Help from '../../../../../components/Help'
import { GenericInput } from '../../../../../components/Inputs'
import ConfigureOptions from '../ConfigureOptions'
import { InputLabel } from '../../../../../components/inputs/InputLabel'
import { templateStyles } from './templateStyles'

export const Form = ({ input, onFormPreviewChange, onInputChange, index }) => {
  const props = input.get('props')
  const options = props.get('preserveOrder')
    ? props.get('options').toJS()
    : props
        .get('options')
        .toJS()
        .sort((a, b) => a.key.localeCompare(b.key))
  return (
    <div>
      <InputLabel
        title={props.get('label')}
        required={props.get('required') && isEmpty(props.get('value'))}
        requiredLabelStyle={templateStyles.requiredLabel}
        requiredLabelIconName={props.get('requiredLabelIconName')}
      >
        <Creatable
          labelKey="key"
          clearable
          // this allows users to create values with ","
          // if they enter in tab or enter, it creates the value
          shouldKeyDownEventCreateNewOption={({ keyCode }) => {
            return (
              [
                9, // tab => fix
                13 // enter => fix
              ].indexOf(keyCode) !== -1
            )
          }}
          options={options}
          onChange={e => {
            // TODO(immutablejs-removal): this component is always using onFormPreviewChange in the actual product form instead of onInputChange.
            //  I think that looks wrong, shouldn't onFormPreviewChange should probably only be used in the template editor?
            //  It looks like the only case where onInputChange would be called is when adding a new option here 🤔
            //  We should should clean this up so it's not so confusing.
            if (e === null) {
              return onFormPreviewChange(index, null)
            }
            if (props.get('options').find(opt => opt.get('key') === e.key)) {
              return onFormPreviewChange(index, e.value)
            }

            return onInputChange(
              index,
              input
                .updateIn(['props', 'options'], i => i.push(Immutable.Map({ value: e.value, key: e.value })))
                .setIn(['props', 'value'], e.value)
            )
          }}
          value={props.get('value')}
          placeholder={props.get('placeholder')}
        />
      </InputLabel>
      {props.get('helpText') && (
        <Help>
          <div>{props.get('helpText')}</div>
        </Help>
      )}
    </div>
  )
}

export const Configuration = ({ input, onChange }) => {
  const inputProps = input.get('props')

  return (
    <div>
      <GenericInput
        title="Placeholder"
        value={inputProps.get('placeholder')}
        onChange={v => onChange('placeholder', v)}
      />
      <ConfigureOptions input={input} onChange={onChange} />
    </div>
  )
}
